import React from 'react'

import { Slide } from "../display_wallet.js"
import { Spaces } from "../components/Spaces"
import { ButtonPrimaryOutlined } from '../components/Buttons.js'


const telegram_link = "https://t.me/+xvrPdKLAkU80ZDg8"

const Slide_ReportBug = (props) => {
	return (
		<Slide num={props.num}>

			<h1>
				<i className="fas fa-flag" />
				<Spaces count="3" />
				Report a bug or get support
			</h1>
			<br /><br />

			<center>

				Nous assurons le support uniquement sur telegram pour le moment. <br /><br />
				Cliquez sur le bouton ci-dessous pour accéder au groupe de support et envoyer votre message<br />
				<br />

				<a href={telegram_link} target="_blank">
					<ButtonPrimaryOutlined>
						open telegram support group &nbsp;&nbsp;
						<i className="fa fa-external-link" />
					</ButtonPrimaryOutlined>
				</a>

			</center>


			<br />

		</Slide >
	)
}

export default Slide_ReportBug
